import React from "react";
import Form from "react-bootstrap/Form";
import { Col } from "react-bootstrap";
import { DateFormat, EnrollmentSteps, formDataDefault, fromOperatorDefault, Validators } from "Utils/Constants";
import "react-datepicker/dist/react-datepicker.css";

import TextField from "Components/Fields/TextField";
import EmailField from "Components/Fields/EmailField";
import DateField from "Components/Fields/DateField";
import PhoneField from "Components/Fields/PhoneField";
import moment from "moment";

const GeneralInfoFields = ({
  formData = formDataDefault,
  fromOperator = fromOperatorDefault,
  onFieldChange = (fieldName, fieldValue, isValid) => { console.warn("onFieldChange not set.") },
  disabled = false
}) => {
  return (
    <Form.Row>
      {fromOperator.general?.includes(EnrollmentSteps.GENERAL.FIRST_NAME) &&
        <Col xs={10} md={5}>
          <TextField
            fieldName="firstName"
            label="FIRST NAME"
            maxLength="20"
            startValue={formData.firstName}
            required={true}
            validators={[Validators.NAME_LENGTH, Validators.NAME_CHARS]}
            onValueChanged={onFieldChange}
            disabled={disabled} />
        </Col>}
      {fromOperator.general?.includes(EnrollmentSteps.GENERAL.MI) &&
        <Col xs={2} md={2}>
          <TextField
            fieldName="middleInitial"
            label="MI"
            maxLength="20"
            startValue={formData.middleInitial}
            validators={[Validators.NAME_LENGTH, Validators.NAME_CHARS]}
            onValueChanged={onFieldChange}
            disabled={disabled} />
        </Col>}
      {fromOperator.general?.includes(EnrollmentSteps.GENERAL.LAST_NAME) &&
        <Col xs={12} md={5}>
          <TextField
            fieldName="lastName"
            label="LAST NAME"
            maxLength="20"
            startValue={formData.lastName}
            required={true}
            validators={[Validators.NAME_LENGTH, Validators.NAME_CHARS]}
            onValueChanged={onFieldChange}
            disabled={disabled} />
        </Col>}
      {fromOperator.general?.includes(EnrollmentSteps.GENERAL.EMAIL) &&
        <Col xs={12} md={6}>
          <EmailField
            fieldName="email"
            label="EMAIL"
            maxLength="40"
            startValue={formData.email}
            required={true}
            onValueChanged={onFieldChange}
            disabled={disabled} />
        </Col>}
      {fromOperator.general?.includes(EnrollmentSteps.GENERAL.DOB) &&
        <Col xs={8} md={6}>
          <DateField
            fieldName="dateOfBirth"
            label="DATE OF BIRTH"
            startValue={formData.dateOfBirth ? moment(formData.dateOfBirth, DateFormat, true).toDate() : undefined}
            required={true}
            onValueChanged={onFieldChange}
            disabled={disabled}
          />
        </Col>}
      {fromOperator.general?.includes(EnrollmentSteps.GENERAL.PHONE) &&
        <Col xs={8} md={6}>
          <PhoneField
            fieldName="mobilePhone"
            label="MOBILE PHONE"
            startValue={formData.mobilePhone}
            required={true}
            onValueChanged={onFieldChange}
          />
        </Col>}
    </Form.Row>
  );
}
export default GeneralInfoFields;
